import { routes } from '@/constants/Constants';

export const zgriNavigationPath = routes.rentersInsurance;
